import React, { useState, useEffect, useRef } from "react";
import Toggle from "./Toggle";
import Tooltip from "./Tooltip";
import SaveButtons from "./SaveButtons";
import Select from "./Select";
import { getCurrency } from "../../utils/helper";

const AdditionalCosts = ({ data, handleUpdate , settings}) => {
  const [isOpen, setIsOpen] = useState(true);
  const [properties, setProperties] = useState([]);
  const [showSave, setShowSave] = useState(false);  
  const inputRefs = useRef([]);

  const inbound_placement_options = ["Minimal", "Partial", "Amazon Optimized"];
  const marketplace_options = ["amazon.co.uk", "amazon.de", "amazon.fr", "amazon.it", "amazon.es", "amazon.com", "amazon.ca"];

  const handleChange = (e, idx) => {
    const value = e.target.value.replace(/[^0-9.]/g, ""); // Remove any non-numeric characters
    const updatedProperties = [...properties];
    updatedProperties[idx].value = value;
    setProperties(updatedProperties);
    setShowSave(true);
  };

  const handleToggleChange = (e, idx) => {
    const updatedProperties = [...properties];
    updatedProperties[idx].value = e;
    setProperties(updatedProperties);
    setShowSave(true);
  };

  const handleSave = () => {
    const updatedData = properties.reduce((acc, property) => {
      const val = property.value;
      const isDollar = property?.title?.includes(getCurrency(settings.marketplace));
      if (val === null || val === undefined || val === "") {
          if(property.property === 'fba_inbound_placement_service'){
          return acc
        }
        acc[property.property] = isDollar ? "0.00" : "0";
      } else {
        acc[property.property] = isDollar ? parseFloat(val).toFixed(2) : val;
      }
      return acc;
    }, {});

    // update the data object
    data = { ...data, ...updatedData };
    handleUpdate(data);
    setShowSave(false);
  };

  const handleCancel = () => {
    setProperties(createPropertiesFromData(data));
    setShowSave(false);
  };

  useEffect(() => {
    setProperties(createPropertiesFromData(data));
  }, [data]);

  const createPropertiesFromData = (data) => {
    return [
      {
        title: "Home Marketplace",
        value: data?.marketplace,
        property: "marketplace",
        text: "Your Amazon home market place that you list and sell your products on.",
        type: "select"
      },
      {
        title: `Minimum Profit(${getCurrency(settings.marketplace)})`,
        value: data?.minProfit,
        property: "minProfit",
        text: "Minimum Profit is the minimum profit you want to set for the product.",
      },
      {
        title: "Minimum ROI(%)",
        value: data?.minroi,
        property: "minroi",
        text: "Minimum ROI is the minimum ROI you want to set for the product.",
      },
      {
        title: `Prep Fee(${getCurrency(settings.marketplace)})`,
        value: data?.prepfee,
        property: "prepfee",
        text: "Prep Fee is the fee you want to set for the product.",
      },
      {
        title: `Misc Fee(${getCurrency(settings.marketplace)})`,
        value: data?.miscfee,
        property: "miscfee",
        text: "Any other cost associated with the product that you want to be added, like some extra percentage of the product cost.",
      },
      {
        title: "Misc Fee(%)",
        value: data?.miscfeepercent,
        property: "miscfeepercent",
        text: "Misc Fee is the fee you want to set for the product.",
      },
      {
        title: "Inbound Shipping Fee(Per LB)",
        value: data?.inbound_shipping || "--",
        property: "inbound_shipping",
        text: "Inbound Shipping Fee is the fee you want to set for the product.",
      },
      {
        title: "Use Peak Storage Fees",
        value: data?.use_peak_storage_fees || false,
        property: "use_peak_storage_fees",
        isToggle: true,
        text: "If it is the fee you want to set for the product.",
      },
      {
        title: "Inbound Placement Fees (FBA)",
        value: data?.fba_inbound_placement_service,
        property: "fba_inbound_placement_service",
        text: "This fee is assessed on a per-unit basis to cover the costs of distributing inventory within Amazon network of fulfillment and FBA centers.",
        type: "select",
      },
    ];
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const handleFocus = (idx) => {
    const input = inputRefs.current[idx];
    const valueLength = properties[idx].value.length;
    input.setSelectionRange(valueLength, valueLength);
  };

  const handleBlurFormatting = (formattedValue, index) => {
    const updatedProperties = [...properties];
    updatedProperties[index].value = formattedValue;
    setProperties(updatedProperties);
  };

  const handleSelectChange = (e, idx) => {
    const value = e;
    const updatedProperties = [...properties];

    updatedProperties[idx].value = value;
    setProperties(updatedProperties);
    setShowSave(true);
  };

  return (
    <div
      className="flex flex-col w-full border-primary bg-primary-bg p-4 mt-4 border border-border/100 rounded-2xl"
    >
      <div
        className="flex cursor-pointer items-center mb-2"
        onClick={toggleAccordion}
      >
        <div
          className="mr-1 text-primary font-bold"
          style={{
            fontSize: "16px",
          }}
        >
          Profit & Cost Settings
        </div>
        <div>{/* {isOpen ? <FaAngleUp /> : <FaAngleDown />} */}</div>
      </div>
      {isOpen && (
        <>
          {properties.map((property, index) => (
            <div
              key={index}
              className={`${property.type === "select" ? "block" : "flex"
                } text-white justify-between bg-secondary-dark p-4 rounded-lg align-center mb-2`}
              style={{
                fontSize: "13px",
              }}
            >
              <div
                className="w-full flex items-center"
                style={{ textAlign: "left" }}
              >
                {property.title} <Tooltip text={property.text} />
              </div>
              <div className={property.type === "select" ? "w-full" : "w-[unset]"}>
                {property.isToggle ? (
                  <Toggle
                    checked={property.value}
                    handleChange={handleToggleChange}
                    idx={index}
                  />
                )
                  : property.type === "select"
                    ? (
                       <Select
                        inputValue={property?.property === "fba_inbound_placement_service" ? property?.value || "Minimal" : property?.value || "amazon.com"}
                        handleDropdownChange={(e) => handleSelectChange(e, index)}
                        dropdownOptions={property?.property === "marketplace" ? marketplace_options : inbound_placement_options}
                      />
                    ) : (
                      <input
                      type="text"
                      value={
                        `${property.title.includes(getCurrency(settings.marketplace)) || property.title.includes("LB") ? getCurrency(settings.marketplace) : ""}${
                          (document.activeElement !== inputRefs.current[index] && 
                           property.value !== undefined && 
                           (property.title.includes(getCurrency(settings.marketplace)) || property.title.includes("LB"))) 
                            ? parseFloat(property.value).toFixed(2) 
                            : property.value
                        }${property.title.includes("%") ? "%" : ""}`
                      }
                      onChange={(e) => {
                        let value = e.target.value;
                        if (property.title.includes(getCurrency(settings.marketplace)) || property.title.includes("LB")) {
                          value = value.replace(getCurrency(settings.marketplace), '');
                        }
                        if (property.title.includes("%")) {
                          value = value.replace('%', '');
                        }
                        handleChange({...e, target: {...e.target, value}}, index);
                      }}
                      onFocus={() => {
                        handleFocus(index);
                        if (inputRefs.current[index] && (property.title.includes(getCurrency(settings.marketplace)) || property.title.includes("LB"))) {
                          const rawValue = property.value?.replace(getCurrency(settings.marketplace), '') || '';
                          inputRefs.current[index].value = rawValue;
                        }
                      }}
                      onBlur={(e) => {
                        if (property.title.includes("%")) return;
                        
                        let value = e.target.value.replace(/[^0-9.]/g, '');
                        
                        if (value && !isNaN(value)) {
                          const formattedValue = parseFloat(value).toFixed(2);
                          handleBlurFormatting(formattedValue, index);
                        } else {
                          handleBlurFormatting('0.00', index);
                        }
                      }}
                      ref={(el) => {
                        inputRefs.current[index] = el;
                        if (el && !el.hasAttribute('data-initialized')) {
                          el.setAttribute('data-initialized', 'true');
                          if (property.value !== undefined && (property.title.includes(getCurrency(settings.marketplace)) || property.title.includes("LB"))) {
                            const dbValue = parseFloat(property.value).toFixed(2);
                            if (!isNaN(dbValue)) {
                              handleBlurFormatting(dbValue, index);
                            }
                          }
                        }
                      }}
                      placeholder={`${getCurrency(settings.marketplace)}20`}
                      className={`text-center text-white border border-primary max-w-[20vw] rounded-xl ${
                        property.title === "Fullfillment" ? "bg-secondary-dark" : "bg-primary-dark"
                      }`}
                      style={{ borderRadius: "12px" }}
                    />
                    )}
              </div>
            </div>
          ))}

          {showSave && (
            <SaveButtons handleSave={handleSave} handleCancel={handleCancel} />
          )}
        </>
      )}
    </div>
  );
};

export default AdditionalCosts;
